import { render, staticRenderFns } from "./VendedorPanel.vue?vue&type=template&id=20946104&scoped=true"
import script from "./VendedorPanel.vue?vue&type=script&lang=js"
export * from "./VendedorPanel.vue?vue&type=script&lang=js"
import style0 from "./VendedorPanel.vue?vue&type=style&index=0&id=20946104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20946104",
  null
  
)

export default component.exports